/**
 * DEX-SOURCE — 장비 출처 라벨의 단일 문. **부위×등급을 실물에서 도출한다.**
 *
 * 등급만 보고 "상점"이라 적었더니 상인이 팔지도 않는 장갑 일반·상급에 상점이
 * 떠 있었다(사용자 실보고 2026-09-04). 정본 셋:
 *   상점   = SLOT_META.shopSale(무기·갑옷 완제품 — 상점 탭·서버 구매 문이 읽는 그 칸)
 *            × 지역 상점 등급 판정(isShopGrade/isShopGradeAt)
 *   운장수 = 상자깡 풀(전 드롭 부위 × 최고급 이하 — gamble 정본 GAMBLE_POOL 과
 *            같은 경계 SHOP_MAX_GRADE)
 *   드롭   = 나머지 전부(신화·궁극 포함)
 *
 * 우선순위(상점 > 운장수·드롭)는 표기 선택이다 — 살 수 있으면 사는 길을 먼저 말한다.
 * `check-dex` 가 서버 표(SLOTS.shopSale·GAMBLE_POOL·DROP_SLOT_POOL)에서 같은 답을
 * 도출해 이 함수와 부위×등급 전수 대조한다 — 어느 쪽이 낡아도 찾아낸다.
 */
import { GLASS_SHOP_ID, RIFT_SHOP_ID, SHOP_MAX_GRADE, isShopGrade, isShopGradeAt } from './map.js';
import { SLOT_META } from './gearnames.js';

export function sourceLabel(slotId, gradeId) {
  const sale = !!SLOT_META[slotId]?.shopSale;
  if (sale && isShopGrade(gradeId)) return '상점';
  if (sale && isShopGradeAt(gradeId, RIFT_SHOP_ID)) return '비늘바람·유리샘 상점'; // 14.551
  if (sale && isShopGradeAt(gradeId, GLASS_SHOP_ID)) return '유리샘 상점';
  if (gradeId <= SHOP_MAX_GRADE) return '운장수·드롭';
  return '드롭';
}

/** 완제품을 파는 부위 이름들 — 안내 산문도 표에서 말한다(손글씨 금지) */
export function shopSaleSlotNames(slotName) {
  return Object.keys(SLOT_META).filter((id) => SLOT_META[id].shopSale).map((id) => slotName[id]);
}
